import React from "react";
import {Image} from "../../../../components/Image";
import "./style.css";
import { getFastingAudienceText, getFastingGenderImage } from "../common/genderAgeProfile";

const GOAL_COPY_MAP = {
    lose_weight: {
        goalText: "lose weight",
        progressText: "weight loss progress"
    },
    get_healthier: {
        goalText: "get healthier",
        progressText: "progress toward better health"
    },
    stay_in_shape: {
        goalText: "stay in shape",
        progressText: "progress toward staying in shape"
    }
};

export const FastingSolution = ({
    clicked,
    clickNext = () => {},
    data,
    isCurPage
}) => {
    const solutionConfig = {
        image: getFastingGenderImage(data?.gender, data?.ageRange),
        audienceText: getFastingAudienceText(data?.gender, data?.ageRange)
    };
    const goalCopy = GOAL_COPY_MAP[data?.mainGoalChoice] || GOAL_COPY_MAP.lose_weight;

    React.useEffect(() => {
        if (clicked && isCurPage) {
            clickNext("continue");
        }
    }, [clicked, clickNext, isCurPage]);

    return (
        <div className="gallery-page fasting-solution-page">
            <div className="fasting-solution-photo-wrap">
                <Image
                    src={solutionConfig.image}
                    alt=""
                    className="fasting-solution-photo"
                    defaultLoad={true}
                />
            </div>

            <div className="fasting-solution-copy">
                <h1 className="fasting-solution-title">The perfect solution is right here!</h1>
                <p className="fasting-solution-description">
                    For <span className="fasting-solution-highlight">{solutionConfig.audienceText}</span>, who want to <span className="fasting-solution-highlight">{goalCopy.goalText}</span>, fasting could be the answer.
                </p>
                <p className="fasting-solution-description">
                    <strong>No dieting and no deprivation</strong>. Eat the foods you love while making <strong>{goalCopy.progressText}!</strong>
                </p>
            </div>
        </div>
    );
};
